import { Component } from '@angular/core';

@Component({
  selector: 'app-httploading-spinner',
  templateUrl: './httploading-spinner.component.html',
  styleUrls: ['./httploading-spinner.component.scss']
})
export class HttploadingSpinnerComponent {

}
